/* MacShack animated logo: pause the gradient drift and glint for visitors who prefer reduced
   motion, and while the tab is hidden. The hover wave is CSS (ms-header.css). */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function apply() {
    var still = (mq && mq.matches) || document.hidden;
    document.querySelectorAll('[data-ms-logo-live]').forEach(function (svg) {
      if (!svg.pauseAnimations) return;
      if (still) { svg.pauseAnimations(); if (mq && mq.matches && svg.setCurrentTime) svg.setCurrentTime(0); }
      else svg.unpauseAnimations();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  document.addEventListener('visibilitychange', apply);
  if (mq && mq.addEventListener) mq.addEventListener('change', apply);
  document.addEventListener('shopify:section:load', apply);
})();
